import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { addFooterNotification, deleteFooterNotification } from 'actions/notifications.js';

const useNotifications = () => {
  const dispatch = useDispatch();

  const handleFooterNotification = useCallback(
    ({
      title,
      message = '',
      type = 'default',
      action = null,
      actionText = null,
      autoHide = true,
      dataTestId = null,
      actionOnClose = null,
    }) => {
      dispatch(addFooterNotification({ title, message, type, action, actionText, autoHide, dataTestId, actionOnClose }));
    },
    [dispatch],
  );

  const clearFooterNotification = useCallback(() => {
    dispatch(deleteFooterNotification());
  }, [dispatch]);

  return { handleFooterNotification, clearFooterNotification };
};

export default useNotifications;
